/**
 * @generated SignedSource<<aea88c3dba7e3393f7a56f27c9d12c26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee";
}>;
export type WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee$key = ReadonlyArray<{
  readonly " $data"?: WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "IntegrationIpoolEmployee",
  "abstractKey": null
};

(node as any).hash = "91bca62ef5b5e1d632c4d5192539b421";

export default node;
